import * as PIXI from 'pixi.js';

export class ExitPopUp extends PIXI.Container {
    constructor(onExit, onClose) {
        super();
        this.onExit = onExit;
        this.onClose = onClose;
        this.interactive = true;
        this.visible = false;

        this.popupWidth = 500;
        this.popupHeight = 300;

        this.createPopup();
        this.onResizeHandler = () => this.resize();
        window.addEventListener('resize', this.onResizeHandler);
    }

    destroy(options) {
        window.removeEventListener('resize', this.onResizeHandler);
        super.destroy(options); // Call super.destroy to clean up PIXI resources
    }

    createPopup() {
        this.overlay = new PIXI.Graphics();
        this.overlay.beginFill(0x000000, 0.5);
        this.overlay.drawRect(0, 0, window.innerWidth, window.innerHeight);
        this.overlay.endFill();
        this.overlay.interactive = true;
        this.addChild(this.overlay);

        this.popupBg = new PIXI.Graphics();
        this.popupBg.beginFill(0x222244, 0.95);
        this.popupBg.drawRoundedRect(0, 0, this.popupWidth, this.popupHeight, 30);
        this.popupBg.endFill();
        this.addChild(this.popupBg);

        this.closeBtn = new PIXI.Graphics();
        this.closeBtn.lineStyle(2, 0xFFFFFF, 1);
        this.closeBtn.moveTo(8, 8);
        this.closeBtn.lineTo(24, 24);
        this.closeBtn.moveTo(24, 8);
        this.closeBtn.lineTo(8, 24);
        this.closeBtn.hitArea = new PIXI.Rectangle(0, 0, 32, 32);
        this.closeBtn.interactive = true;
        this.closeBtn.cursor = 'pointer';
        this.closeBtn.on('pointertap', () => this.onClose());
        this.addChild(this.closeBtn);

        const buttonContainer = new PIXI.Container();
        const buttonWidth = 220;
        const buttonHeight = 60;

        const exitButtonBg = new PIXI.Graphics();
        exitButtonBg.beginFill(0x6a0dad);
        exitButtonBg.drawRoundedRect(0, 0, buttonWidth, buttonHeight, 10);
        exitButtonBg.endFill();
        buttonContainer.addChild(exitButtonBg); 

        const exitButtonTextStyle = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 24,
            fontWeight: 'bold',
            fill: '#ffffff',
        });
        const exitButtonText = new PIXI.Text('Exit Game', exitButtonTextStyle);
        exitButtonText.anchor.set(0.5);
        exitButtonText.x = buttonWidth / 2;
        exitButtonText.y = buttonHeight / 2;
        buttonContainer.addChild(exitButtonText); 

        buttonContainer.interactive = true;
        buttonContainer.cursor = 'pointer';
        buttonContainer.hitArea = new PIXI.Rectangle(0, 0, buttonWidth, buttonHeight);
        buttonContainer.on('pointertap', () => {
            if (this.onExit) {
                this.onExit();
            }
        });
        
        this.exitButtonContainer = buttonContainer; 
        this.addChild(this.exitButtonContainer); 

        this.resize(); 
    }

    show() {
        this.visible = true;
        if (this.parent) {
            this.parent.setChildIndex(this, this.parent.children.length - 1);
        }
    }

    hide() {
        this.visible = false;
    }

    resize() {
        const screenWidth = window.innerWidth;
        const screenHeight = window.innerHeight;

        if (!this.overlay) { // Defensive check: if overlay is null, re-create it
            this.overlay = new PIXI.Graphics();
            this.addChildAt(this.overlay, 0); // Re-add to ensure it's at the bottom
            this.overlay.interactive = true;
        }

        this.overlay.width = screenWidth;
        this.overlay.height = screenHeight;

        let currentPopupWidth = 500;
        let currentPopupHeight = 300;
        let buttonWidth = 220;
        let buttonHeight = 60;
        let fontSize = 24;
        let closeBtnScale = 1;

        if (screenWidth <= 480) { // Small mobile
            currentPopupWidth = screenWidth * 0.8;
            currentPopupHeight = screenHeight * 0.4;
            buttonWidth = 180;
            buttonHeight = 50;
            fontSize = 20;
            closeBtnScale = 0.6;
        } else if (screenWidth <= 767) { // Regular mobile
            currentPopupWidth = screenWidth * 0.7;
            currentPopupHeight = screenHeight * 0.35;
            buttonWidth = 200;
            buttonHeight = 55;
            fontSize = 22;
            closeBtnScale = 0.8;
        }

        if (!this.popupBg) { // Defensive check: if popupBg is null, re-create it
            this.popupBg = new PIXI.Graphics();
            this.addChild(this.popupBg); // Re-add to stage
        }

        this.popupBg.clear();
        this.popupBg.beginFill(0x222244, 0.95);
        this.popupBg.drawRoundedRect(0, 0, currentPopupWidth, currentPopupHeight, 30);
        this.popupBg.endFill();
        this.popupBg.x = (screenWidth - currentPopupWidth) / 2;
        this.popupBg.y = (screenHeight - currentPopupHeight) / 2;

        if (this.closeBtn) { // Defensive check for closeBtn
            this.closeBtn.x = this.popupBg.x + currentPopupWidth - (32 * closeBtnScale) - 10;
            this.closeBtn.y = this.popupBg.y + 10;
            this.closeBtn.scale.set(closeBtnScale);
        }

        if (this.exitButtonContainer) {
           // Update button background size
            const exitButtonBg = this.exitButtonContainer.children[0];
            if(exitButtonBg) {
                exitButtonBg.clear();
                exitButtonBg.beginFill(0x6a0dad);
                exitButtonBg.drawRoundedRect(0, 0, buttonWidth, buttonHeight, 10);
                exitButtonBg.endFill();
            }
            

            // Update button text size and position
            const exitButtonText = this.exitButtonContainer.children[1];
            if(exitButtonText) {
                exitButtonText.style.fontSize = fontSize;
                exitButtonText.x = buttonWidth / 2;
                exitButtonText.y = buttonHeight / 2;
            }
            

            // Update hit area
            this.exitButtonContainer.hitArea = new PIXI.Rectangle(0, 0, buttonWidth, buttonHeight);

            this.exitButtonContainer.x = this.popupBg.x + (currentPopupWidth - buttonWidth) / 2;
            this.exitButtonContainer.y = this.popupBg.y + (currentPopupHeight - buttonHeight) / 2;
        }
    }
}